import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ToastService } from '../components/ui/toast/toast.services';


export const onboardingGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const http = inject(HttpClient);
  const router = inject(Router);
  const toast = inject(ToastService);

  if(!auth.loggedIn()) return true;

  try {
    const result = await firstValueFrom(
      http.get<{ data: {onboardingComplete: number} }>(
        `${environment.apiUrlV1}/onboarding/status`
      )
    );

    if(!result.data.onboardingComplete) {
      return router.createUrlTree(['/onboarding']);
    }

    return true;
  } catch {
   // toast.error('Server nicht erreichbar. Bitte versuchen sie es später erneut.');
    return true;
  }
};

// Verhindern das fertige User nochmals zum Onboarding geht
export const onboardingCompleteGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const http = inject(HttpClient);
  const toast = inject(ToastService);

  if(!auth.loggedIn()) return router.createUrlTree(['/']);

  try {
    const result = await firstValueFrom(
      http.get<{ data: {onboardingComplete: number} }>(
        `${environment.apiUrlV1}/onboarding/status`
      )
    );

    // Bereits vollständig -> zur App
    if(result.data.onboardingComplete) {
      return router.createUrlTree(['/bestand']);
    }
    return true;
  } catch {
    //toast.warning('Onboarding-Status konnte nicht geladen werden');
    return true;
  }
};
